import React, {Component} from 'react'
import PropTypes from 'prop-types'
import { Button, Progress, ButtonGroup, Input, InputGroup, InputGroupAddon } from 'reactstrap'
import { getUserPermissions } from '../../../utils/userPermissions'

const tdStyle = { verticalAlign: 'middle' };
const showPlannedDates = () => getUserPermissions('wl_welds.show_planned_dates.show_planned_dates')
const showCompanies = () => getUserPermissions('wl_welds.show_companies.show_companies')
const showWeldingProgress = () => getUserPermissions('wl_welds.show_welding_progress.show_welding_progress')
const showInspectionProgress = () => getUserPermissions('wl_welds.show_inspection_progress.show_inspection_progress')

const ElementRow = ({ element, onEdit, onDestroy, history, companiesData }) => {
  return (
    <tr className="tr-render-list" onClick={() => {
      history.push(`/projects/welds/${element.id}`)
    }}>
      <td style={tdStyle}><b>{element.id}</b></td>
      <td style={tdStyle}>{element.name}</td>
      {showCompanies() && <td style={tdStyle}>{element.project_companies && (typeof element.project_companies === 'string' ? JSON.parse(element.project_companies) : element.project_companies).map(pc => { const c = companiesData.find(o => String(o.id) === String(pc.id)); return c ? <span key={pc.id} style={pc.executor ? {color: '#20a8d8', fontWeight: 'bold'} : {}}>{c.name}</span> : null }).filter(Boolean).reduce((acc, el, i) => i === 0 ? [el] : [...acc, ', ', el], [])}</td>}
      {showPlannedDates() && <td style={tdStyle}>{element.planned_start_date}</td>}
      {showPlannedDates() && <td style={tdStyle}>{element.planned_end_date}</td>}
      {showWeldingProgress() && <td style={tdStyle}>
        {element.company_permitted && <div>
          <div className="clearfix">
            <div className="float-left">
              <strong>{element.welding_progress}%</strong>
            </div>
          </div>
          <Progress className="progress-xs" value={element.welding_progress} />
        </div>}
      </td>}
      {showInspectionProgress() && <td style={tdStyle}>
        {element.company_permitted && Array.isArray(element.inspection_progress) && element.inspection_progress.length > 0 && (
          <div>
            {element.inspection_progress.map((insp) => (
              <div key={insp.inspection_category_type_id} className="mb-1 d-flex align-items-center">
                <span style={{ minWidth: 32, marginRight: 8, fontWeight: 500 }}>{insp.name}</span>
                <div style={{ flex: 1 }}>
                  <Progress className="progress-xs" value={insp.percent}>
                    <span className="sr-only">{insp.percent}%</span>
                  </Progress>
                </div>
                <span style={{ marginLeft: 8, minWidth: 32 }}>
                  {insp.percent}%
                  {/* {insp.count_failed > 0 ? (
                    <span style={{ color: '#F00', fontWeight: 'bold', marginLeft: 4 }}>
                      ({insp.count_failed})
                    </span>
                  ) : (
                    <span style={{ color: 'green', fontWeight: 'bold', marginLeft: 4 }}>
                      (0)
                    </span>
                  )} */}
                </span>
              </div>
            ))}
          </div>
        )}
      </td>}
      <td style={tdStyle}>
        {element.company_permitted && <ButtonGroup size='sm' className="float-right">
          {onEdit && getUserPermissions('wl_welds.projects.update') &&
            <Button id="edit-project-btn" color="warning" title="Edit" onClick={(e) => {
              e.stopPropagation()
              onEdit(element)
            }
            }>
              <i className="fa fa-edit" />
            </Button>}
          {onDestroy && getUserPermissions('wl_welds.projects.destroy') &&
            <Button id="remove-project-btn" color="danger" title="Remove" onClick={(e) => {
              e.stopPropagation()
              onDestroy(element.id)
            }}>
              <i className="fa fa-trash-o" />
            </Button>}
        </ButtonGroup>}
      </td>
    </tr>
  )
}

ElementRow.propTypes = {
  element: PropTypes.object.isRequired,
  history: PropTypes.object.isRequired,
  onEdit: PropTypes.func,
  onDestroy: PropTypes.func,
  companiesData: PropTypes.array.isRequired
}

const Colgroup = () => (
  <colgroup>
    <col style={{width: '60px'}} />
    <col />
    {showCompanies() && <col />}
    {showPlannedDates() && <col style={{width: '130px'}} />}
    {showPlannedDates() && <col style={{width: '130px'}} />}
    {showWeldingProgress() && <col style={{width: '150px'}} />}
    {showInspectionProgress() && <col style={{width: '200px'}} />}
    <col style={{width: '100px'}} />
  </colgroup>
)

class ElementsList extends Component {
  constructor(props) {
    super(props)
    this.state = {nameFilter: props.initialNameFilter || ''}
  }

  handleSubmit = () => {
    this.props.onNameFilter(this.state.nameFilter)
  }

  handleKeyDown = (e) => {
    if (e.key === 'Enter') this.handleSubmit()
  }

  handleClear = () => {
    this.setState({nameFilter: ''}, () => this.props.onNameFilter(''))
  }

  render() {
    const {elements, history, onEdit, onDestroy, companiesData, scrollRef, heightOffset} = this.props
    const {nameFilter} = this.state
    return (
      <div>
        <div style={{marginBottom: 8}}>
          <InputGroup>
            <Input
              placeholder="Filter by name..."
              value={nameFilter}
              onChange={e => this.setState({nameFilter: e.target.value})}
              onKeyDown={this.handleKeyDown}
              disabled={this.props.loading}
            />
            <InputGroupAddon addonType="append">
              <Button color="primary" onClick={this.handleSubmit} disabled={this.props.loading}>
                <i className="fa fa-filter"/> Filter
              </Button>
              <Button color="secondary" onClick={this.handleClear} disabled={this.props.loading}>
                <i className="fa fa-times"/> Clear
              </Button>
            </InputGroupAddon>
          </InputGroup>
        </div>
      <table className="table" style={{tableLayout: 'fixed', marginBottom: 0}}>
        <Colgroup />
        <thead>
          <tr>
            <th style={{width: '60px'}}>ID</th>
            <th>Name</th>
            {showCompanies() && <th>Companies</th>}
            {showPlannedDates() && <th style={{width: '130px'}}>Planned start date</th>}
            {showPlannedDates() && <th style={{width: '130px'}}>Planned end date</th>}
            {showWeldingProgress() && <th style={{width: '150px'}}>Welding progress</th>}
            {showInspectionProgress() && <th style={{width: '200px'}}>Inspections progress</th>}
            <th style={{width: '100px'}}>Actions</th>
          </tr>
        </thead>
      </table>
      <div ref={scrollRef} style={{height: `calc(100vh - ${heightOffset}px)`, overflowY: 'auto'}} onScroll={this.props.onScroll}>
        <table className="table" style={{tableLayout: 'fixed', marginBottom: 0}}>
          <Colgroup />
          <tbody>
            {elements.map(element => (
              <ElementRow
                key={element.id}
                history={history}
                element={element}
                onEdit={onEdit}
                onDestroy={onDestroy}
                companiesData={companiesData}
              />
            ))}
          </tbody>
        </table>
      </div>
    </div>
    )
  }
}

ElementsList.propTypes = {
  elements: PropTypes.array,
  history: PropTypes.object.isRequired,
  onEdit: PropTypes.func,
  onDestroy: PropTypes.func,
  onNameFilter: PropTypes.func.isRequired,
  companiesData: PropTypes.array.isRequired,
  scrollRef: PropTypes.object,
  heightOffset: PropTypes.number,
  initialNameFilter: PropTypes.string,
  loading: PropTypes.bool
}
ElementsList.defaultProps = {
  elements: [],
  heightOffset: 280,
  initialNameFilter: '',
  loading: false
}


export default ElementsList



// WEBPACK FOOTER //
// ./src/components/Projects/helpers/ElementsList.js